import { useEffect } from "react";

const AdsterraBanner = () => {
  useEffect(() => {
    window.atOptions = {
      key: "56aa218a4625cb9e89310d0350a0bdc9",
      format: "iframe",
      height: 250,
      width: 300,
      params: {},
    };

    const script = document.createElement("script");
    script.src =
      "https://bauval.org/22/56aa218a4625cb9e89310d0350a0bdc9";
    script.async = true;

    const container = document.getElementById(
      "adsterra-banner-300x250"
    );

    if (container) {
      container.innerHTML = "";
      container.appendChild(script);
    }

    return () => {
      if (container) {
        container.innerHTML = "";
      }
    };
  }, []);

  return (
    <div
      id="adsterra-banner-300x250"
      className="w-[300px] h-[250px] overflow-hidden"
    />
  );
};

export default AdsterraBanner;